import { useEffect } from 'react'

const GestureHandler = ({ children }) => {
  useEffect(() => {
    const eventListener = (event) => {
      if (
        event.detail.action === 'MOUSE-DOWN' ||
        event.detail.action === 'POINTER-DOWN'
      ) {
        const pointer = event.detail.action === 'POINTER-DOWN'
        const move = event.detail.move
        const up = event.detail.up
        const position = { x: event.detail.x || 0, y: event.detail.y || 0 }
        const relative = event.detail.relative
        const onMove = (event) => {
          move(event.clientX - position.x, event.clientY - position.y)
          if (relative) {
            position.x = event.clientX
            position.y = event.clientY
          }
        }
        const onUp = (event) => {
          up(event.clientX - position.x, event.clientY - position.y)
          document.body.removeEventListener(
            pointer ? 'pointermove' : 'mousemove',
            onMove,
            false
          )
          document.body.removeEventListener(
            pointer ? 'pointerup' : 'mouseup',
            onUp,
            false
          )
        }
        document.body.addEventListener(
          pointer ? 'pointermove' : 'mousemove',
          onMove,
          false
        )
        document.body.addEventListener(
          pointer ? 'pointerup' : 'mouseup',
          onUp,
          false
        )
      }
    }
    const element = document.body
    element.addEventListener('GestureHandlerEvent', eventListener, false)
    return () => {
      element.removeEventListener('GestureHandlerEvent', eventListener, false)
    }
  }, [])

  return children
}

const gestureEvent = ({ action, ...extraData }) => {
  return new CustomEvent('GestureHandlerEvent', {
    bubbles: true,
    cancelable: true,
    detail: {
      action,
      ...extraData
    }
  })
}

export default GestureHandler
export { gestureEvent }
